import {withdrawalSvg as Icon__small__withdrawalSvg} from '../Icon__small/Icon__small--withdrawal.js'

export var withdrawal = {
  name: 'withdrawal',
  category: 'icon',
  colorable: true,
  svg: Icon__small__withdrawalSvg,
};
